module.exports = __webpack_public_path__ + "static/media/exercices-empty.8d2c1b55.svg";